<template>
  <div class="w-100 overflow-hidden" style=" height: 100vh;">
    <iframe src="https://datastudio.google.com/embed/reporting/97b20148-b8d2-4d02-99e3-0e3b211e0223/page/p_lwqafemhnd" 
      frameborder="0" allowfullscreen  width="100%" style="border:0; height: 100vh; margin: 0;"
      sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox">
    </iframe>
  </div>
</template>

<script>
import { computed, onMounted, ref} from 'vue';
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useI18n } from 'vue-i18n';

export default {
  name: "ResultadosAcademicos",
  setup() {
    const { t } = useI18n();
    const message = ref('You are not logged in!');
    const imageUrl = ref(''); // For storing the image URL
    const store = useStore();
    const router = useRouter();
    const user = computed(() => store.state.user);

    const isTokenValid = () => {
      const token = localStorage.getItem('authToken')
      if (!token) return false;

      try {
        const [, payloadBase64] = token.split('.');
        const payload = JSON.parse(atob(payloadBase64));
        const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
        console.log('currenttime:'+currentTime)
        console.log('payload:'+payload.exp)
        return payload.exp > currentTime; // Comparar el tiempo de expiración
      } catch (error) {
        console.error('Error al decodificar el token:', error);
        return false;
      }
    };

    onMounted(async () => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      if (isTokenValid()) {
        console.log('El token es válido.');
      } else {
        console.log('El token ha expirado.');
        const url = window.location.href; 
        const cleanedUrl = url.split("/#")[1];
        if(cleanedUrl!="/login"){
          localStorage.setItem('redirectAfterLogin', cleanedUrl);
        }
        store.dispatch('logOut');
        await router.push('/login');
      }
      if (user.value && user.value.email) {
        if(user.value.email.some(emails => emails.email.includes('@goethe.edu.ar'))){
          console.log('Tiene permiso');
        }
        else{
          await router.push('/');
        }
      }
    })
    return {
      message,
      imageUrl,
      t,
    }
  }
}
</script>
<style scoped>
</style>